class Selector {
  constructor(type, instance) {
    this.type = type;
    this.instance = instance;
  }
}

export default Selector;